import React from 'react';
import { useAdDimensions } from 'app/components/ads/useAdDimensions';
import { AdCore } from 'app/components/ads/AdCore';
import { useAdUnitCode } from 'app/components/ads/adHelpers';
// AdSlotContainer: Component to set configuration to define ad slot
// only triggered in CSR
const AdSlotContainer = _ref => {
  let {
    adUnit,
    limitedDim,
    className,
    adSlotId
  } = _ref;
  const dimensions = useAdDimensions(limitedDim);
  const sizes = dimensions[adUnit];
  // adUnitCode needs to be unique for each container per page
  const adUnitCode = useAdUnitCode(adUnit);
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    "data-sentry-component": "AdSlotContainer",
    "data-sentry-source-file": "AdSlotContainer.tsx"
  }, /*#__PURE__*/React.createElement(AdCore, {
    id: adSlotId !== null && adSlotId !== void 0 ? adSlotId : "ad-".concat(adUnit),
    adUnitCode: adUnitCode,
    sizes: sizes,
    "data-sentry-element": "AdCore",
    "data-sentry-source-file": "AdSlotContainer.tsx"
  }));
};
export { AdSlotContainer };